import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class Base64Service {
  convertBase64ToWebP(base64Data: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();

      img.onload = () => {
        try {
          const canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext('2d');
          if (!ctx) {
            reject('Error al obtener el contexto del canvas');
            return;
          }
          ctx.drawImage(img, 0, 0);
          const webpDataUrl = canvas.toDataURL('image/webp', 0.8);
          resolve(webpDataUrl);
        } catch (error) {
          reject(`Error al convertir la imagen: ${error}`);
        }
      };

      img.onerror = () => {
        reject('Error al cargar la imagen base64');
      };

      img.src = base64Data;
    });
  }
}
